import React, { useState } from 'react';
import './notfound.css';

const NotFoundPage = () => {
  const [formData, setFormData] = useState({
    subject: '',
    name: '',
    email: '',
    service: '',
    phone: '',
    website: '',
    message: '',
    attachment: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log(formData);
  };

  return (
    // <section id="contact" className="contact section light-background">
    // <div className="support-form-container">
    //   <h2>Raise a Support Ticket</h2>
    //   <p>Support Timing: 11 AM to 8 PM</p>
    //   <form onSubmit={handleSubmit}>
    //     <div className="form-group">
    //       <label>Subject</label>
    //       <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />
    //     </div>
    //     <div className="form-group">
    //       <label>Your name</label>
    //       <input type="text" name="name" value={formData.name} onChange={handleChange} required />
    //     </div>
    //     <div className="form-group">
    //       <label>Email Address</label>
    //       <input type="email" name="email" value={formData.email} onChange={handleChange} required />
    //     </div>
    //     <div className="form-group">
    //       <label>Service</label>
    //       <select name="service" value={formData.service} onChange={handleChange} required>
    //         <option value="">Select a service</option>
    //         <option value="service1">Service 1</option>
    //         <option value="service2">Service 2</option>
    //         <option value="service3">Service 3</option>
    //       </select>
    //     </div>
    //     <div className="form-group">
    //       <label>Phone Number</label>
    //       <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
    //     </div>
    //     <div className="form-group">
    //       <label>Website URL</label>
    //       <input type="url" name="website" value={formData.website} onChange={handleChange} required />
    //     </div>
    //     <div className="form-group">
    //       <label>Message</label>
    //       <textarea name="message" value={formData.message} onChange={handleChange} required></textarea>
    //     </div>
    //     <div className="form-group">
    //       <label>Attachments</label>
    //       <input type="file" name="attachment" onChange={handleChange} />
    //     </div>
    //     <button type="submit">Submit</button>
    //   </form>
    // </div>
    // </section>
    <section id="home" className="hero home section ">
    <div className="container">
      <div className="row gy-4">
      
    <div className="support-form-container dark-background">
    <h2>Raise a Support Ticket</h2>
    <p>Support Timing: 11 AM to 8 PM</p>
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Subject</label>
        <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Your name</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Email Address</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Service</label>
        <select name="service" value={formData.service} onChange={handleChange} required>
          <option value="">Select a service</option>
          <option value="service1">Domain issues</option>
          <option value="service2">Server issues</option>
          <option value="service3">Website issues</option>
          <option value="service4">Email issues</option>
        </select>
      </div>
      <div className="form-group">
        <label>Phone Number</label>
        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Website URL</label>
        <input type="url" name="website" value={formData.website} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Message</label>
        <textarea name="message" value={formData.message} onChange={handleChange} required></textarea>
      </div>
      <div className="form-group">
        <label>Attachments</label>
        <input type="file" name="attachment" onChange={handleChange} />
      </div>
      <button type="submit">Submit</button>
    </form>
   </div>
      </div>
    </div>
  </section>
  );
};

export default NotFoundPage;
